<template>
  <BaseBrick
      :scale="scale"
      :ch="ch"
      :class-name="'beton-brick'"
      :cw="cw"
      :l1x="l1x"
      :l1y="l1y"
      :l2x="l2x"
      :l2y="l2y"
      :step="step"
      :tx="tx"
      :ty="ty"
      :x="x"
      :y="y"
      :vl="vl"
  />
</template>

<script>
import BaseBrick from "@/components/BaseBrick";
export default {
  name: "BetonBrick",
  components : { BaseBrick },
  props: {
    x: Number,
    y: Number,
    tx: Number,
    ty: Number,
    l1x: Number,
    l1y: Number,
    l2x: Number,
    l2y: Number,
    step: Number,
    scale: Number,
    cw: Number,
    ch: Number,
    vl: Number
  }
}
</script>
